<!--view for admin-->
<template>
    <div class="admin-view">
      <Heading/>
      <div class="flex flex-auto">
        <ProfileList/>
        <div class="main">
          <ProfilePage/>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from '@/router';
import Heading from '@/components/Heading.vue';
import ProfileList from '@/components/ProfileList.vue';
import ProfilePage from '@/components/ProfilePage.vue';

export default {
  name: 'Profile',
  components: { Heading, ProfileList, ProfilePage },
  computed: {
    ...mapGetters({
      connected: 'connected',
  }),
  },
  watch: {
  connected (newValue, oldValue) {
    if (newValue) {
      this.$store.dispatch('changeToAdmin');
      if (this.$route.params.profileId) {
        this.$store.dispatch('setSelectedProfile', this.$route.params.profileId);
      }
    }
  },

  },
  mounted() {
    this.$store.dispatch('getCompanies');
  }
}
</script>

<style scoped>
  .admin-view {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  .main {
    overflow: hidden;
    background-color: #fff;
    flex: auto;
  }
</style>
